import React from "react";

import { render, screen, waitFor } from "@testing-library/react";

import ColecaoDeCartasDoAluno from "./ColecaoDeCartasDoAluno";
import axios from "../../../config/axios";

jest.mock("../../../config/axios", () => ({
  __esModule: true,
  default: { get: jest.fn() }
}));

/* O acervo aqui é o REAL (o catálogo em código), de propósito: esta ponte existe
   justamente para casar a resposta do servidor com ele, e um acervo falso não provaria
   que os `card_id` do banco batem com os ids das cartas. É também o único teste que
   quebra se alguém renomear uma carta — que é a operação sem conserto do módulo. */
const UMA_CARTA_REAL = "nordeste-problema-01";

/* O console.warn é a única saída visível quando a rota não responde (a seção some), e
   os testes exercitam justamente esse caminho. Silenciado para o relatório do jest não
   virar uma parede de avisos esperados. */
let avisos;
beforeEach(() => {
  jest.clearAllMocks();
  avisos = jest.spyOn(console, "warn").mockImplementation(() => {});
});
afterEach(() => avisos.mockRestore());

describe("ColecaoDeCartasDoAluno", () => {
  it("busca a coleção do aluno e mostra o que ele tem", async () => {
    axios.get.mockResolvedValue({
      data: {
        success: true,
        data: {
          cards: [
            {
              cardId: UMA_CARTA_REAL,
              region: "nordeste",
              rarity: "comum",
              obtainedAt: "2026-08-01 10:00:00"
            }
          ]
        }
      }
    });

    const onResumo = jest.fn();
    render(<ColecaoDeCartasDoAluno token="tok" onResumo={onResumo} />);

    await waitFor(() =>
      expect(
        screen.getByText(/Toque numa carta para ver de perto/)
      ).toBeInTheDocument()
    );

    expect(axios.get).toHaveBeenCalledWith(
      expect.stringContaining("activity/ludic-trail/collection"),
      { headers: { authorization: "Bearer tok" } }
    );
    // Uma carta conquistada, e o restante do acervo como silhueta — é a coleção
    // incompleta, que é o que esta tela existe para mostrar.
    expect(
      document.querySelectorAll(".colecao__carta-botao--silhueta").length
    ).toBeGreaterThan(0);

    // O CONTADOR SOBE PARA A MOLDURA da seção em vez de ser desenhado aqui: nesta
    // página o título e o "1 de 44" são iguais para todo tipo de conquista.
    /* `waitFor` E NÃO ASSERÇÃO DIRETA, e a razão foi medida: o `waitFor` do DOM acima
       resolve assim que o texto aparece, e nesse instante o efeito que publica o resumo
       ainda está pendente — `onResumo.mock.calls` estava vazio, e o efeito aparecia no
       log DEPOIS da asserção. Sem esta espera o teste reprova um código correto. */
    await waitFor(() =>
      expect(onResumo).toHaveBeenCalledWith(
        expect.objectContaining({ conquistadas: 1, total: expect.any(Number) })
      )
    );
    expect(screen.queryByText(/Você já descobriu/)).toBeNull();
  });

  it("A SEÇÃO SOME quando a rota não existe", async () => {
    // O backend da feature pode não estar publicado no ambiente — já aconteceu com
    // `POST .../experience`. Um bloco de erro no meio das medalhas não serve ao aluno,
    // que não pode consertá-lo; quem precisa saber é quem está testando, e para isso
    // fica o aviso no console.
    axios.get.mockRejectedValue({ response: { status: 404 } });

    const { container } = render(<ColecaoDeCartasDoAluno token="tok" />);

    await waitFor(() => expect(container).toBeEmptyDOMElement());
    expect(avisos).toHaveBeenCalledWith(
      expect.stringContaining("o backend desta feature não está publicado")
    );
  });

  it("a seção some também no 200 com `success: false`", async () => {
    // É como este backend devolve erro de aplicação, então não cai no catch.
    axios.get.mockResolvedValue({
      data: { success: false, error: "Erro ao buscar a coleção." }
    });

    const { container } = render(<ColecaoDeCartasDoAluno token="tok" />);

    await waitFor(() => expect(container).toBeEmptyDOMElement());
    expect(avisos).toHaveBeenCalledWith(
      expect.stringContaining("respondeu sem sucesso"),
      "Erro ao buscar a coleção."
    );
  });

  it("sem token não chama o servidor e não desenha nada", () => {
    const { container } = render(<ColecaoDeCartasDoAluno />);

    expect(axios.get).not.toHaveBeenCalled();
    expect(container).toBeEmptyDOMElement();
  });

  it("AVISA quando o aluno tem carta que o catálogo não conhece", async () => {
    // A única falha silenciosa possível aqui: `card_id` renomeado depois de a coleção
    // existir. A carta desaparece da tela sem erro nenhum, e quem perde é o aluno.
    axios.get.mockResolvedValue({
      data: {
        success: true,
        data: {
          cards: [
            { cardId: "amazonia-problema-01", region: "norte", rarity: "comum" }
          ]
        }
      }
    });

    render(<ColecaoDeCartasDoAluno token="tok" />);

    await waitFor(() =>
      expect(avisos).toHaveBeenCalledWith(
        expect.stringContaining("amazonia-problema-01")
      )
    );
  });
});
